import { SubmissionStatus } from '@bp/bp-graphql-types';
import i18next from 'i18next';

export function getSubmissionStatusTranslation(state: SubmissionStatus, context: 'teacher' | 'student'): string {
  if (context === 'teacher') {
    switch (state) {
      case SubmissionStatus.Done:
        return i18next.t('submissions.status.done', { context: 'teacher' });
      case SubmissionStatus.Draft:
        return i18next.t('submissions.status.draft', { context: 'teacher' });
      case SubmissionStatus.Feedback:
        return i18next.t('submissions.status.feedback', { context: 'teacher' });
      case SubmissionStatus.New:
        return i18next.t('submissions.status.new', { context: 'teacher' });
      case SubmissionStatus.Todo:
        return i18next.t('submissions.status.todo', { context: 'teacher' });
      case SubmissionStatus.Updated:
        return i18next.t('submissions.status.updated', { context: 'teacher' });
      default:
        return '';
    }
  } else {
    switch (state) {
      case SubmissionStatus.Done:
        return i18next.t('submissions.status.done', { context: 'student' });
      case SubmissionStatus.Draft:
        return i18next.t('submissions.status.draft', { context: 'student' });
      case SubmissionStatus.Feedback:
        return i18next.t('submissions.status.feedback', { context: 'student' });
      case SubmissionStatus.New:
        return i18next.t('submissions.status.new', { context: 'student' });
      case SubmissionStatus.Todo:
        return i18next.t('submissions.status.todo', { context: 'student' });
      case SubmissionStatus.Updated:
        return i18next.t('submissions.status.updated', { context: 'student' });
      default:
        return '';
    }
  }
}

export function getSubmissionStatusColor(state: SubmissionStatus | 'delayed'): string {
  switch (state) {
    case SubmissionStatus.Done:
    case SubmissionStatus.New:
      return 'var(--color-finished)';
    case SubmissionStatus.Draft:
      return 'var(--color-workinprogress)';
    case SubmissionStatus.Feedback:
      return 'var(--color-tocorrect)';
    case SubmissionStatus.Todo:
      return 'var(--color-unprocessed)';
    case SubmissionStatus.Updated:
      return 'var(--color-error)';
    case 'delayed':
      return 'var(--color-grey-lightest)';
    default:
      return '';
  }
}
